import { render, staticRenderFns } from "./Financials.vue?vue&type=template&id=477082fe&"
import script from "./Financials.vue?vue&type=script&lang=js&"
export * from "./Financials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports